<template>
    <div class="report__dashboard_show_systemusage">
        <div class="report__dashboard_show_systemusage_main">
            <template v-if="requestPending">
                <component-loading :size="'small'"></component-loading>
            </template>
            <template v-else>
                <div class="container">
                    <div class="columns is-block-touch columns--margin-2-mobile columns--spacing columns--spacing-top">
                        <div class="column is-12-tablet is-4-desktop has-text-centered-touch">
                            <report-dashboard-show-system-usage-box
                                :label="'Users'"
                                :dispatch-name="'ebsReportDashboardGetDataSystemUsageUsers'"
                                :getter-name="'getEbsReportDashboardDataSystemUsageUsers'"
                            ></report-dashboard-show-system-usage-box>
                        </div>
                        <div class="column is-12-tablet is-4-desktop has-text-centered has-text-centered-touch">
                            <report-dashboard-show-system-usage-box
                                ref="systemusagelogins"
                                :label="'Average logins per day'"
                                :dispatch-name="'ebsReportDashboardGetDataSystemUsageLogins'"
                                :getter-name="'getEbsReportDashboardDataSystemUsageLogins'"
                                :extra-options="true"
                                :select-option="systemUsageFiltersSelectOption"
                                :checkbox-option="systemUsageFiltersCheckboxOption"
                                @emit-filter-select="handleSetSystemUsageFilters('logins_select', ...arguments)"
                                @emit-filter-checkbox="handleSetSystemUsageFilters('logins_checkbox', ...arguments)"
                            ></report-dashboard-show-system-usage-box>
                        </div>
                        <div class="column is-12-tablet is-4-desktop has-text-right has-text-centered-touch">
                            <report-dashboard-show-system-usage-box
                                :label="'Hours of training time'"
                                :dispatch-name="'ebsReportDashboardGetDataSystemUsageTrainingTime'"
                                :getter-name="'getEbsReportDashboardDataSystemUsageTrainingTime'"
                            ></report-dashboard-show-system-usage-box>
                        </div>
                    </div>
                    <div class="columns is-block-touch columns--margin-2-mobile columns--spacing columns--spacing-bottom">
                        <div class="column is-12-tablet is-4-desktop has-text-centered-touch">
                            <report-dashboard-show-system-usage-box
                                :label="'Courses'"
                                :dispatch-name="'ebsReportDashboardGetDataSystemUsageCourses'"
                                :getter-name="'getEbsReportDashboardDataSystemUsageCourses'"
                            ></report-dashboard-show-system-usage-box>
                        </div>
                        <div class="column is-12-tablet is-4-desktop has-text-centered has-text-centered-touch">
                            <report-dashboard-show-system-usage-box
                                :label="'Total enrolments'"
                                :dispatch-name="'ebsReportDashboardGetDataSystemUsageTotalEnrolments'"
                                :getter-name="'getEbsReportDashboardDataSystemUsageTotalEnrolments'"
                            ></report-dashboard-show-system-usage-box>
                        </div>
                        <div class="column is-12-tablet is-4-desktop has-text-right has-text-centered-touch">
                            <report-dashboard-show-system-usage-box
                                :label="'Total completions'"
                                :dispatch-name="'ebsReportDashboardGetDataSystemUsageTotalCompletions'"
                                :getter-name="'getEbsReportDashboardDataSystemUsageTotalCompletions'"
                            ></report-dashboard-show-system-usage-box>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import ReportDashboardShowSystemUsageBox from '@/components/ebs/reports/dashboard/show/ReportDashboardShowSystemUsageBox'
import ComponentLoading from '@/components/default/shared/ComponentLoading'

export default {
  name: 'report-dashboard-show-system-usage',
  components: { ComponentLoading, ReportDashboardShowSystemUsageBox },
  data () {
    return {
      requestPending: true
    }
  },
  computed: {
    systemUsageFilters () {
      return this.$store.getters.getEbsReportDashboardFiltersPermanentSystemUsage
    },
    systemUsageFiltersSelectOption () {
      const filters = this.systemUsageFilters
      const filterLoginsSelect = filters.length ? filters.find(obj => obj.key === 'logins_select') : null
      return filterLoginsSelect ? filterLoginsSelect.values : 'year'
    },
    systemUsageFiltersCheckboxOption () {
      const filters = this.systemUsageFilters
      const filterLoginsCheckbox = filters.length ? filters.find(obj => obj.key === 'logins_checkbox') : null
      return filterLoginsCheckbox ? filterLoginsCheckbox.values : true
    }
  },
  methods: {
    getSystemUsageFilters () {
      this.requestPending = true
      this.$store.dispatch('ebsReportDashboardGetFilters', 'system_usage').finally(() => {
        this.requestPending = false
      })
    },
    handleSetSystemUsageFilters (key, values) {
      this.$store.dispatch('ebsReportDashboardSetFilters', {
        filterKey: 'system_usage',
        type: 'permanent',
        data: {
          key: key,
          values: values
        }
      })
      this.$store.dispatch('ebsReportDashboardUpdateFilters', { filterKey: 'system_usage' })
    }
  },
  created () {
    this.getSystemUsageFilters()
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/reports/_reportdashboardsystemusage.scss";
</style>
